/**
 * Trap Quest Definitions
 *
 * NOTE: Trap tutorial quests have been integrated into the main quest chains
 * in tutorialQuests.ts (tut_trap_life, lake_craw_daddy).
 * This file is kept for backward compatibility with imports.
 */

import { QuestDefinition, QuestChain } from '@/types';

/**
 * All trap quest definitions (empty — now in main chains)
 */
export const TRAP_QUEST_DEFINITIONS: QuestDefinition[] = [];

/**
 * Default quest chains for trapping (empty — now in main chains)
 */
export const TRAP_QUEST_CHAINS: QuestChain[] = [];
